<template>
    <el-dialog :title="$t('ita_btn_notify_client')" :visible.sync="hereShow" width="60%">
        <div>
            <el-form style="margin-bottom: 10px" label-width="200px" label-position="left">
                <el-form-item :label="$t('recevier')">
                    <el-select v-model="recevier" multiple filterable clearable>
                        <el-option v-for="(v, k) in options" :key="k" :label="v.userName" :value="v.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item :label="$t('ccer')">
                    <el-select v-model="cc" multiple filterable clearable>
                        <el-option v-for="(v, k) in ccOptions" :key="k" :label="v.userName" :value="v.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button class="cancel-btn" @click="show = false" :loading="loading">{{
                $t('btn_cancel')
            }}</el-button>
            <el-button type="primary" class="cancel-btn" :loading="loading" @click="onSend('myself')">{{
                $t('send_me_a_preview')
            }}</el-button>
            <el-button class="wl-green" type="primary" @click="onSend" :loading="loading">{{
                $t('comment_send')
            }}</el-button>
        </span>
    </el-dialog>
</template>
<script>
import { mapGetters } from 'vuex'
import API from '@/api'

export default {
    name: 'NoticeUndone',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        summaryList: {
            type: Array,
            default: () => []
        }
    },
    data() {return {
        hereShow: false,
        loading: false,
        recevier: [],
        cc: [],
        options: [],
        ccOptions: []
    }},
    mounted() {
        this.hereShow = this.show
        if (this.getUser.userType == '1') {
            this.getEmailReciverOptions()
        }
    },
    methods: {
        onSend(e) {
            if (e !== 'myself' && this.recevier.length == 0) {
                this.$message.error(this.$t('please_choose_recevier'))
                return
            }
            this.loading = true
            API.exchange.sendItuFileNotifyEmail({
                summaryList: this.summaryList,
                sendUserIdList: e == 'myself' ? ['myself'] : this.recevier,
                ccUserIdList: e == 'myself' ? [] : this.cc,
                siteId: this.getSite.siteId
            }).then(res => {
                if (res.code === '1') {
                    this.$message.success(this.$t('msg_success'))
                    this.hereShow = false
                } else {
                    this.$message.error(this.$t(res.code))
                }
            }).finally(() => {
                this.loading = false
            })
        },
        // 获取发送邮件的人的列表
        getEmailReciverOptions() {
            API.exchange.queryClientUserList({ siteId: this.getSite.siteId }).then((res) => {
                if (res.code == '1') {
                    this.options = res.data
                } else {
                    this.$message.error(this.$t(res.code))
                }
            })
            API.status.queryKPMemberBySite({ siteId: this.getSite.siteId, userType: '1' }).then((res) => {
                this.ccOptions = res.data
            })
        },
    },
    computed: {
        ...mapGetters('common', {
            getUser: 'getUser',
            getSite: 'getSite'
        }),
    },
    watch: {
        show(v) {
            this.hereShow = v
        },
        hereShow(v) {
            this.$emit('update:show', v)
        }
    }
}
</script>